// extracted by mini-css-extract-plugin
module.exports = {"select":"roleSelection_select__1ma5E","note":"roleSelection_note__2vfQC"};